// src/template-parts/blocks/google-map/google-map.tsx
// NOTE: JSX is compiled by Babel to wp.element.* (see babel config below)
import GoogleMap from './google-map-react';

type Location = {
  markerColour: string;
  name: string;
  location: string;
  position: { lat: number; lng: number };
  latitude: number;
  longitude: number;
  description: string;
  employmentType: string;
};

function mount(container: Element, node: JSX.Element): void {
  const el = (window as any)?.wp?.element;
  if (!el) {
    console.error('wp.element is not available');
    return;
  }
  if (typeof el.createRoot === 'function') {
    // React 18 pathway
    const root = el.createRoot(container);
    root.render(node);
  } else if (typeof el.render === 'function') {
    // React 17 pathway
    el.render(node, container);
  } else {
    console.error('Neither wp.element.createRoot nor wp.element.render found');
  }
}

const interactiveMap = (): void => {
  const sections = document.querySelectorAll<HTMLElement>('[data-google-map]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const apiKey = section.getAttribute('data-google-map-api-key');
    const mapContainer = section.querySelector<HTMLElement>(
      '[data-google-map-container]'
    );

    if (!apiKey) return;
    if (!mapContainer) return;

    const showCountryNames = section.hasAttribute('data-show-country-names');

    let locations: Location[] = [];
    const script = section.querySelector<HTMLScriptElement>(
      'script[data-google-map-locations]'
    );

    if (script?.textContent) {
      try {
        locations = JSON.parse(script.textContent) as Location[];
      } catch (err) {
        console.error('Invalid JSON in data-google-map-locations', err);
      }
    }

    mount(
      mapContainer,
      <GoogleMap section={section} apiKey={apiKey} locations={locations} showCountryNames={showCountryNames} />
    );
  });
};

export default interactiveMap;
